module.exports = __webpack_public_path__ + "static/img/gm_benefit04.686e5c65.png";